import { useState } from 'react';
import {
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ColumnPopupProps {
    open: boolean;
    onClose: () => void;
    onSave: (align: 'C' | 'L' | 'R') => void;
}

export function ColumnPopup({ open, onClose, onSave }: ColumnPopupProps) {
    const { t } = useTranslation();
    const [align, setAlign] = useState<'C' | 'L' | 'R'>('C');

    const handleChange = (event: SelectChangeEvent<'C' | 'L' | 'R'>) => {
        setAlign(event.target.value);
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t('form.alignment')}</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="align-select">
                        {t('form.alignment')}
                    </InputLabel>
                    <Select
                        id="align-select"
                        value={align}
                        onChange={handleChange}
                        label={t('form.alignment')}
                    >
                        <MenuItem value="C">{t('form.centered')}</MenuItem>
                        <MenuItem value="L">{t('form.left')}</MenuItem>
                        <MenuItem value="R">{t('form.right')}</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {t('Cancel')}
                </Button>
                <Button onClick={() => onSave(align)} color="primary">
                    {t('Save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
